import React from 'react';
import { classNames } from '@panwds/react-ui';

function TopNav({ children, addClassName, dataMetrics, dataTestId, }) {
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || "top-nav", className: "tw-box-border tw-flex tw-flex-col tw-min-h-0" },
        React.createElement("ul", { className: classNames("tw-overflow-y-auto tw-scrollbar-default tw-scrollbar-no-track dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark tw-overflow-x-hidden tw-box-border tw-list-none tw-m-0 tw-p-0 tw-b-0", addClassName) }, children)));
}

export { TopNav };
//# sourceMappingURL=TopNav.esm.js.map
